import { Routes } from "react-router";
import imgInicial from "../../../../assets/images/inicial2.png";
import CarruselJardin from "../../../../components/pages/proyectoeducativo/nivelinicial/carruselJardin";

import MenuInteremedioNiveles from "../menuInteremedioNiveles";
function homeinicial() {


  return (

    <div>
      <CarruselJardin />
      <MenuInteremedioNiveles />

      <div className="m-5 shadow-lg p-3"   style={{  backgroundColor: "#294235", borderRadius: "20px", }} id = "texto-jardin">
        <h2 className="text-white text-center mb-4" style={{ fontWeight: "bold", letterSpacing: "1px" }}>
          Nivel Inicial
        </h2>
        <p className="lead text-white fs-5" style={{ lineHeight: "1.8", marginBottom: "24px" }}>
          En el <strong>Colegio Santo Tomás</strong>, la educación inicial ofrece oportunidades de aprendizaje que
          promueven el desarrollo integral de los niños y niñas. Fomentamos una comprensión progresiva de la
          realidad, así como la interacción positiva con sus pares y con los adultos, brindando además espacios
          para la construcción de nuevos conocimientos.        </p>
        <p className="text-white fs-5" style={{ lineHeight: "1.8", marginBottom: "20px" }}>
          Nuestra institución se enfoca en la integración de los más pequeños, ayudándolos a desarrollar su
          autonomía y conocimiento personal, fomentando la confianza en sus capacidades y el respeto hacia sus
          propios límites.        </p>
      </div>





    </div>
  );
}

export default homeinicial;